import { Seo, breadcrumbSchema, faqSchema } from "../components/site/Seo";
import { PageHero } from "../components/site/PageHero";
import { FaqList } from "../components/site/FaqList";
import { CtaBand } from "../components/site/Cta";
import { FAQ } from "../data/faq";

export default function Faq() {
  const crumbs = [{ to: "/", label: "Accueil" }, { to: "/faq", label: "FAQ" }];
  return (
    <>
      <Seo title="FAQ pare-brise Haguenau : prix, assurance, ADAS, optiques | A+ Glass" description="Toutes les réponses sur le remplacement de pare-brise, la réparation d'impact, la calibration ADAS, la rénovation de phares et l'assurance à Haguenau." path="/faq" schemas={[faqSchema(FAQ), breadcrumbSchema(crumbs)]} />
      <PageHero eyebrow="Questions fréquentes" title="FAQ pare-brise, vitrage et optiques" crumbs={crumbs} intro="Les réponses aux questions que nous posent le plus souvent nos clients à Haguenau." />
      <section className="px-5 py-16 lg:px-8">
        <div className="mx-auto max-w-[920px]"><FaqList items={FAQ} prefix="faq-page" /></div>
      </section>
      <CtaBand title="Vous ne trouvez pas votre réponse ?" />
    </>
  );
}
